import React, { FC, Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Paper } from '@material-ui/core';
import classNames from 'classnames';

import { ContentInput } from 'api';
import { ValidatedCheckbox } from 'components';
import { hasPhoto, hasVideo } from 'features/content/helpers';
import { useCurrentUser } from 'hooks';

import TitleTextField from '../Partials/TitleTextField';
import BodyTextField from '../Partials/BodyTextField';
import MediaUpload from './MediaUpload';
import MediaPreview from './MediaPreview';
import CancelIcon from '@material-ui/icons/Cancel';
import { isContributorAndAbove } from '../../helpers';

const useStyles = makeStyles(theme => ({
  paperDefault: {
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  paper: {
    minHeight: '176px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: theme.spacing(2),
  },
}));

const ImageVideoForm: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const user = useCurrentUser();
  const { values, setFieldValue } = useFormikContext<ContentInput>();
  const { content_object } = values;

  const [hasContent, setHasContent] = useState(false);

  useEffect(() => {
    if (hasVideo(values) || hasPhoto(values)) {
      setHasContent(true);
    }
  }, [content_object]);

  function onClickRemove() {
    setFieldValue('content_object.media', null);
    setFieldValue('content_object.photos', null);

    setHasContent(false);
  }

  return (
    <Fragment>
      <TitleTextField />

      <Paper
        variant="outlined"
        className={classNames(classes.paperDefault, { [classes.paper]: !hasContent })}>
        {hasContent ? <MediaPreview /> : <MediaUpload />}
        {hasContent && (
          <IconButton onClick={onClickRemove} className={classes.removeButton}>
            <CancelIcon />
          </IconButton>
        )}
      </Paper>

      <BodyTextField />

      <ValidatedCheckbox name="is_shareable" label={t('posting:shareable')} color="primary" />
      {isContributorAndAbove(user) && (
        <ValidatedCheckbox name="is_branded" label={t('posting:branded')} color="primary" />
      )}
    </Fragment>
  );
};

export default ImageVideoForm;
